import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { trpc } from "@/lib/trpc";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { AdminLayout } from "./AdminLayout";

export default function AdminMembersPage() {
  const users = trpc.admin.listUsers.useQuery();
  const utils = trpc.useUtils();
  const setRole = trpc.admin.setUserRole.useMutation({
    onSuccess: () => {
      toast.success("권한을 변경했습니다.");
      utils.admin.listUsers.invalidate();
    },
    onError: (e) => toast.error(e.message),
  });

  return (
    <AdminLayout>
      <h1 className="font-serif text-2xl text-primary mb-6">회원 관리</h1>
      {users.isLoading ? (
        <div className="py-20 flex justify-center">
          <Loader2 className="animate-spin text-muted-foreground" />
        </div>
      ) : (
        <Card>
          <CardContent className="p-0">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="text-xs uppercase text-muted-foreground bg-muted/40">
                  <tr>
                    <th className="text-left p-3">이름</th>
                    <th className="text-left p-3">이메일</th>
                    <th className="text-left p-3">로그인</th>
                    <th className="text-left p-3">권한</th>
                    <th className="text-left p-3">가입일</th>
                    <th className="p-3"></th>
                  </tr>
                </thead>
                <tbody>
                  {users.data?.map((u) => (
                    <tr key={u.id} className="border-t border-border/60">
                      <td className="p-3">{u.name ?? "—"}</td>
                      <td className="p-3">{u.email ?? "—"}</td>
                      <td className="p-3 text-muted-foreground">
                        {u.loginMethod ?? "—"}
                      </td>
                      <td className="p-3">
                        <span
                          className={
                            "text-xs px-2 py-0.5 rounded-full " +
                            (u.role === "admin"
                              ? "bg-primary text-primary-foreground"
                              : "bg-secondary text-secondary-foreground")
                          }
                        >
                          {u.role}
                        </span>
                      </td>
                      <td className="p-3 text-xs text-muted-foreground">
                        {new Date(u.createdAt).toLocaleDateString("ko-KR")}
                      </td>
                      <td className="p-3 text-right">
                        <Button
                          size="sm"
                          variant="outline"
                          disabled={setRole.isPending}
                          onClick={() =>
                            setRole.mutate({
                              userId: u.id,
                              role: u.role === "admin" ? "user" : "admin",
                            })
                          }
                        >
                          {u.role === "admin" ? "일반 회원으로" : "관리자로"}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      )}
    </AdminLayout>
  );
}
